/*
  HYPE SIDE — Movimento da página inicial

  Um só ciclo de requestAnimationFrame para todos os efeitos ligados ao
  scroll. O JS só mede posições e escreve variáveis CSS (--p, --hs-exit);
  quem desenha é o CSS (hs-motion.css e hs-trio.css), sempre
  com transform/opacity, para não obrigar o browser a refazer o layout.

  Só corre com a classe `hs-motion` no <html>, posta no <head> do
  theme.liquid. Fica de fora no editor do tema e para quem pede menos
  animações no sistema: aí a página é a de sempre, estática.
*/
(function () {
  'use strict';

  var html = document.documentElement;
  if (!html.classList.contains('hs-motion')) return;
  window.HSMotion = true;

  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var vh = window.innerHeight;
  var stick = 0;
  var items = [];
  var queued = false;

  /* ---------- Altura do cabeçalho fixo (o banner "sai" por baixo dele) ---------- */
  var header = document.querySelector('.section-header');
  function measure() {
    vh = window.innerHeight;
    stick = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
  }
  measure();

  /* ---------- Progresso de scroll ----------
     view : 0 quando o topo entra por baixo, 1 quando a base sai por cima
     exit : 0 encostado ao cabeçalho, 1 quando a base passa o cabeçalho
     enter: 0 com o topo a 92% do ecrã, 1 com o topo a 42% */
  function progress(mode, r) {
    switch (mode) {
      case 'view': return (vh - r.top) / (vh + r.height);
      case 'exit': return (stick - r.top) / r.height;
      default: return (vh * 0.92 - r.top) / (vh * 0.5);
    }
  }

  var near = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.__hs.on = e.isIntersecting; });
    queue();
  }, { rootMargin: '25% 0px 25% 0px' });

  function track(el, mode, fn) {
    if (!el) return;
    var it = { el: el, mode: mode, fn: fn, on: false, p: -1 };
    el.__hs = it;
    items.push(it);
    near.observe(el);
  }
  function setP(name) {
    return function (p) { this.el.style.setProperty(name, p.toFixed(4)); };
  }

  function frame() {
    queued = false;
    var live = [];
    var rects = [];
    // Primeiro todas as leituras, depois todas as escritas
    for (var i = 0; i < items.length; i++) {
      if (items[i].on) { live.push(items[i]); rects.push(items[i].el.getBoundingClientRect()); }
    }
    for (var k = 0; k < live.length; k++) {
      var it = live[k];
      var p = clamp(progress(it.mode, rects[k]), 0, 1);
      if (p !== it.p) {
        it.p = p;
        it.fn.call(it, p);
      }
    }
  }
  function queue() {
    if (!queued) { queued = true; requestAnimationFrame(frame); }
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', function () { measure(); queue(); });
  window.addEventListener('load', function () { measure(); queue(); });

  /* ---------- Entradas (uma vez, ao aparecer) ---------- */
  var REVEAL = [
    '.hs-sechead',
    '.hs-clubs__grid',
    '.hs-cats__grid',
    '.hs-rail__scroller',
    '.hs-rail__more',
    '.hs-benefits__grid',
    '.hs-reviews__grid',
    '.hs-railbanner',
    '.hs-railbanner__body',
    '.hs-trio__panels',
    '.hs-trio__crests',
    '.hs-promo__inner',
    '.hs-cta__inner'
  ].join(',');

  var seen = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      seen.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px' });

  document.querySelectorAll(REVEAL).forEach(function (group) {
    for (var i = 0; i < group.children.length; i++) {
      group.children[i].style.setProperty('--i', Math.min(i, 8));
    }
    seen.observe(group);
  });

  /* ---------- Benefícios: logo abaixo do banner, entram sozinhos ao carregar ---------- */
  document.querySelectorAll(".hs-benefits__grid").forEach(function (g) {
    seen.unobserve(g);
    function enter() { setTimeout(function () { g.classList.add("is-in"); }, 350); }
    if (document.readyState === "complete") enter();
    else window.addEventListener("load", enter, { once: true });
    window.addEventListener("pageshow", function (ev) { if (ev.persisted) g.classList.add("is-in"); });
  });

  /* ---------- Banner principal: afunda e escurece ao sair ---------- */
  track(document.querySelector('[data-hsbn]'), 'exit', setP('--hs-exit'));

  /* ---------- Parallax dentro das molduras ---------- */
  document.querySelectorAll('.hs-cat, .hs-review__photo, .hs-railbanner, [data-hs-fan], [data-hs-drift]').forEach(function (el) {
    track(el, 'view', setP('--p'));
  });

  /* ---------- CTA final: as palavras acendem com o scroll ---------- */
  document.querySelectorAll('.hs-cta .hs-h2').forEach(function (h) {
    var words = h.textContent.trim().split(/\s+/);
    h.textContent = '';
    words.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'hs-w';
      s.style.setProperty('--i', i);
      s.textContent = w;
      h.appendChild(s);
      if (i < words.length - 1) h.appendChild(document.createTextNode(' '));
    });
    h.style.setProperty('--n', words.length);
    track(h, 'enter', setP('--p'));
  });

  queue();
})();
